import { ACCOUNTS_TTL_MS } from '../../utils/query-config';

export function shouldFetchAccounts(connection: any, forceRefresh: boolean): boolean {
  try {
    const hasAccounts = Array.isArray(connection?.accounts) && connection.accounts.length > 0;
    const last = connection?.lastAccountsFetch as Date | string | null | undefined;
    const lastDate = last instanceof Date ? last : (last ? new Date(String(last)) : null);
    const cacheValid = !!lastDate && (Date.now() - lastDate.getTime()) < ACCOUNTS_TTL_MS;

    // Only skip fetching if we have accounts AND cache is valid AND not forcing refresh
    return !( !forceRefresh && cacheValid && hasAccounts );
  } catch {
    return true; // default to fetching on errors
  }
}

export function shouldSkipPositions(accounts: any[], connection: any): boolean {
  try {
    const anyPositionsHint = (accounts || []).some((a: any) => Array.isArray(a?.positions) && (a.positions?.length || 0) > 0);
    const allCash = (accounts || []).every((a: any) => (a?.classification?.cdn_asset_class || '').toLowerCase() === 'cash');
    const hasFetchedBefore = !!connection?.lastPositionsFetch;
    return !anyPositionsHint && allCash && hasFetchedBefore;
  } catch {
    return false;
  }
}
